import { render, staticRenderFns } from "./FiltrosProjetos.vue?vue&type=template&id=ad5ac9e4&scoped=true"
import script from "./FiltrosProjetos.vue?vue&type=script&lang=ts"
export * from "./FiltrosProjetos.vue?vue&type=script&lang=ts"
import style0 from "./FiltrosProjetos.vue?vue&type=style&index=0&id=ad5ac9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5ac9e4",
  null
  
)

export default component.exports